import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
// import {MyStore} from './myreducer';
import { ContentErrors } from '../../model/content/contenterror.model';

@Injectable({
  providedIn: 'root'
})
export class ErrorMessagesReducerStoreService {
  public errorMessages: Observable<any>;

  constructor(private store: Store<any>) {
    this.errorMessages = store.select('errorMessageReducer');
  }

  loadDetails(common: any) {
    const content = new ContentErrors(common);
    this.store.dispatch({ type: 'LOAD_ERROR_MESSAGE', payload: content });
  }
}
